import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import WebRoutes from "./routes/WebRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./sass/style.scss";
import { UserRoleProvider } from "services/provider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { UserProvider } from "./context/UserContext";
import "react-activity/dist/library.css";
import Loader from "./components/Loader";

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
  }
  //   <Lottie
  //   animationData={loadingAnimation}
  //   loop={true}
  //   style={{ width: 150, height: 150 }}
  // />
  return (
    <UserProvider>
      <UserRoleProvider>
        <Router basename={process.env.REACT_APP_BASENAME}>
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <Loader   />
              {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
            </div>
          ) : (
            <WebRoutes />
          )}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </Router>
      </UserRoleProvider>
    </UserProvider>
  );
}

export default App;
